import { MessageCircle } from "lucide-react";
import { CONTACT } from "@/data/services";
import { TID } from "@/constants/testIds/site";

export default function FloatingWhatsapp() {
  return (
    <a
      href={`https://wa.me/${CONTACT.whatsappRaw}?text=${encodeURIComponent(
        "Bonjour, je souhaite en savoir plus sur vos packs Digital Création Promo."
      )}`}
      target="_blank"
      rel="noreferrer"
      data-testid={TID.floating.whatsapp}
      aria-label="Contacter sur WhatsApp"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white grid place-items-center wa-pulse shadow-2xl hover:scale-110 transition-transform"
      style={{ transition: "transform 0.35s cubic-bezier(0.22,1,0.36,1)" }}
    >
      <MessageCircle size={24} fill="white" />
    </a>
  );
}
